import { createGoodsReqChallanContent, createOrderContent } from "../../store/api/content";
import { uploadFile } from "../../store/api/file";
import store from "../../store/store";
import { UPLOAD_FILE_CONTENT_NAME, UPLOAD_FILE_CONTENT_TYPE, UPLOAD_FILE_PURPOSE_TYPE } from "../constants/constants";

export const uploadFileWrapper = async (file: any, type: string, contentRefId: string) => {
    try {
        if(!file){
            throw new Error("File not found!");
        }
        const errorsList: string[] = [];
        const allowedFileTypes = ["png", "jpg", "jpeg", "pdf", "vnd.openxmlformats-officedocument.spreadsheetml.sheet", "vnd.openxmlformats-officedocument.wordprocessingml.document"];
        const allowedFileFormats = ["image", "application"]
        const fileType = file?.[0]?.type?.split("/");
        const fileSize = file?.[0]?.size;

        const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100 MB
        if (fileSize > MAX_FILE_SIZE) {
            const sizeInMB = (fileSize / (1024 * 1024)).toFixed(2); // Convert bytes to MB with 2 decimal places
            errorsList.push("File size exceeds the allowed limit.");
            errorsList.push(`Current size: ${fileSize} bytes (${sizeInMB} MB)`);
        }

        if (fileType && (!allowedFileTypes.includes(fileType[1]) || !allowedFileFormats.includes(fileType[0]))) {
            errorsList.push("File Format Not Accepted");
        }

        if(errorsList.length > 0){
            const errorObjects = errorsList.map((msg) => new Error(msg));
            throw new AggregateError(errorObjects, "File validation failed.");
        }

        let loadingVariable: string = type;
        let purposeTypeVariable: string = "";
        let documentType: string = file[0].mime?.includes("image")
                    ? UPLOAD_FILE_CONTENT_TYPE.IMAGE
                    : UPLOAD_FILE_CONTENT_TYPE.DOCUMENT;
        let description: string = "";

        switch(type){
        case "signedOrder":
            purposeTypeVariable = UPLOAD_FILE_PURPOSE_TYPE.SIGNED_PO;
            description = UPLOAD_FILE_CONTENT_NAME.SIGNED_PO;
            break;
        case "signedInvoice":
            purposeTypeVariable = UPLOAD_FILE_PURPOSE_TYPE.SIGNED_INVOICE;
            description = UPLOAD_FILE_CONTENT_NAME.SIGNED_INVOICE;
            break;
        case "signedDeliveryChallan":
            purposeTypeVariable = UPLOAD_FILE_PURPOSE_TYPE.SIGNED_DELIVERY_CHALLAN;
            description = UPLOAD_FILE_CONTENT_NAME.SIGNED_DELIVERY_CHALLAN;
            break;
        }

        const formData = new FormData();
        formData.append("file", file[0], file[0].name);
        formData.append("filePurposeType", purposeTypeVariable);
        console.log(formData);
        const uploadFileRes = await store.dispatch(uploadFile(formData)).unwrap()
        console.log("Upload File Res: ", uploadFileRes);
        const contentReqBody: any = {
            contentTypeId: documentType,
            contentName: description,
            description: description,
            mimeTypeId: uploadFileRes?.data?.mime,
            objectInfo: uploadFileRes?.data?.path,
            purposeTypes: [purposeTypeVariable],
        };
        if(type === "signedOrder"){
            contentReqBody["orderId"] = contentRefId
            const orderContent = await store.dispatch(createOrderContent(contentReqBody)).unwrap()
            return {orderContent, uploadFileRes};
        }
        else if(type === "signedDeliveryChallan"){
            contentReqBody["goodsReqChallanId"] = contentRefId
            const orderContent = await store.dispatch(createGoodsReqChallanContent(contentReqBody)).unwrap()
            return {orderContent, uploadFileRes};
        }
        else if(type === "signedInvoice"){
            contentReqBody["orderId"] = contentRefId
            const orderContent = await store.dispatch(createOrderContent(contentReqBody)).unwrap()
            return {orderContent, uploadFileRes};
        }
        return {uploadFileRes}
    }
    catch(err:any){
        throw err;
    }
}